import { render, staticRenderFns } from "./_region.vue?vue&type=template&id=47dbf40e&scoped=true&"
import script from "./_region.vue?vue&type=script&lang=js&"
export * from "./_region.vue?vue&type=script&lang=js&"
import style0 from "./_region.vue?vue&type=style&index=0&id=47dbf40e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dbf40e",
  null
  
)

export default component.exports